import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-curriculum-failed',
  templateUrl: './curriculum-failed.component.html',
  styleUrls: ['./curriculum-failed.component.scss']
})
export class CurriculumFailedComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();

}